import { ExcelOptions } from "../models/excel-options";


export abstract class IExcelBuilder {
    abstract build(config: ExcelOptions, sampleData: any[])
}
